module.exports = __webpack_public_path__ + "img/modi-top-finished-img.4682d7a1.png";